<template>
    <div class="app-container">

        <div class="filter-head" style="max-height:100px;">
            <div class="filter-box" style="min-width: 690px;">
                <div class="filter-item">
                    <el-input v-model="listQuery.product_name" placeholder="产品名称" clearable />
                </div>
                <div class="filter-item">
                    <el-input v-model="listQuery.user_name" placeholder="用户名" clearable />
                </div>
                <div class="filter-item">
                    <el-select v-model="listQuery.is_merchant_activity" placeholder="是否商户活动" clearable>
                        <el-option label="是" :value="1" />
                        <el-option label="否" :value="0" />
                    </el-select>
                </div>
                <div class="filter-item">
                    <el-select v-model="listQuery.type" placeholder="测评类型" clearable @change="onChangeType"
                        @clear="onClearType">
                        <el-option label="产品体验" :value="1" />
                        <el-option label="探店体验" :value="2" />
                    </el-select>
                </div>
                <div class="filter-item">
                    <el-select :loading="classifyLoading" v-model="listQuery.evaluation_class_id" placeholder="分类" clearable
                        :disabled="!listQuery.type">
                        <el-option v-for="item in classifyList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </div>
                <div class="filter-item">
                    <el-select v-model="listQuery.state" placeholder="状态" clearable>
                        <el-option label="申请中" :value="0"></el-option>
                        <el-option label="申请成功" :value="1"></el-option>
                        <el-option label="申请失败" :value="-1"></el-option>
                        <el-option label="已发货" :value="2"></el-option>
                        <el-option label="待提交初稿" :value="3"></el-option>
                        <el-option label="待审核初稿" :value="4"></el-option>
                        <el-option label="初稿审核失败" :value="5"></el-option>
                        <el-option label="待提交终稿" :value="6"></el-option>
                        <el-option label="待审核终稿" :value="7"></el-option>
                        <el-option label="终稿审核失败" :value="8"></el-option>
                        <el-option label="已完成" :value="9"></el-option>
                        <el-option label="订单已关闭" :value="10"></el-option>
                        <el-option label="订单取消" :value="11"></el-option>
                        <el-option label="选择我不去了" :value="12"></el-option>
                        <el-option label="待发放积分" :value="13"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="filter-item" style="margin-left:20px;width: 250px;flex-shrink: 0;">
                <el-button type="primary" :loading="tableLoading" icon="el-icon-search" @click="handleFilter">查询</el-button>
                <el-button type="warning" :loading="tableLoading" icon="el-icon-upload2"
                    @click="exportExcel">导出Excel</el-button>
            </div>
        </div>

        <div class="table" style="margin-top: 20px;">
            <el-table v-loading="tableLoading" :data="tableData" border height="65vh" fit highlight-current-row>
                <el-table-column type="index" label="序号" width="95" align="center" />
                <el-table-column prop="order_id" label="订单号" min-width="110" align="center" />
                <el-table-column prop="user_info.name" label="用户名" min-width="110" align="center" />
                <el-table-column prop="evaluation.name" label="产品名称" min-width="110" align="center" />
                <el-table-column label="产品图片" min-width="200" align="center">
                    <template slot-scope="scope">
                        <img style="width:150px; height: 150px;" :src="scope.row.evaluation.cover_img_vertical" alt="商品图" />
                    </template>
                </el-table-column>


                <el-table-column prop="state" label="状态" min-width="150" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state === 0" type="primary">申请中</el-tag>
                        <el-tag v-else-if="scope.row.state === 1" type="primary">申请成功</el-tag>
                        <el-tag v-else-if="scope.row.state === -1" type="danger">申请失败</el-tag>
                        <el-tag v-else-if="scope.row.state === 2" type="primary">已发货</el-tag>
                        <el-tag v-else-if="scope.row.state === 3" type="primary">待提交初稿</el-tag>
                        <el-tag v-else-if="scope.row.state === 4" type="warning">待审核初稿</el-tag>
                        <el-tag v-else-if="scope.row.state === 5" type="danger">初稿审核失败</el-tag>
                        <el-tag v-else-if="scope.row.state === 6" type="primary">待提交终稿</el-tag>
                        <el-tag v-else-if="scope.row.state === 7" type="warning">待审核终稿</el-tag>
                        <el-tag v-else-if="scope.row.state === 8" type="danger">终稿审核失败</el-tag>
                        <el-tag v-else-if="scope.row.state === 9" type="success">已完成</el-tag>
                        <el-tag v-else-if="scope.row.state === 10" type="danger">订单已关闭</el-tag>
                        <el-tag v-else-if="scope.row.state === 11" type="danger">订单取消</el-tag>
                        <el-tag v-else-if="scope.row.state === 12" type="danger">选择我不去了</el-tag>
                        <el-tag v-else-if="scope.row.state === 13" type="success">待发放积分</el-tag>
                        <el-tag v-else>后端无字段</el-tag>
                    </template>
                </el-table-column>


                <el-table-column label="推广平台" min-width="150" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.channel_pathList && scope.row.channel_pathList.length > 0">
                            <span v-for="(item, index) in scope.row.channel_pathList" :key="index">
                                <img style="width: 30px; height: 30px;margin: 0 10px" :src="item" fit="cover" />
                            </span>

                        </div>
                    </template>
                </el-table-column>


                <!-- <el-table-column prop="created_at" label="提交时间" min-width="110" align="center" /> -->
                <el-table-column prop="created_at" label="最新操作时间" min-width="110" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.user_last_at">
                            {{ scope.row.user_last_at }}
                        </div>
                        <div v-else>
                            -
                        </div>
                    </template>
                </el-table-column>



                <el-table-column prop="evaluation.merchant_info.name" label="商家" min-width="110" align="center" />
                <el-table-column prop="evaluation.evaluation_class_info.name" label="测评类型" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.evaluation.type === 1">产品体验</el-tag>
                        <el-tag v-else-if="scope.row.evaluation.type === 2">探店体验</el-tag>
                        <el-tag v-else>后端无字段</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="evaluation.evaluation_class_info.name" label="分类" min-width="110" align="center" />

                <el-table-column prop="evaluation.is_merchant_activity" label="是否商户活动" min-width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.evaluation.is_merchant_activity == 1" type="success">是</el-tag>
                        <el-tag v-else type="danger">否</el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="application_number" label="申请次数" min-width="95" align="center" />
                <el-table-column prop="first_draft_examine_num" label="初稿审核次数" min-width="95" align="center" />
                <el-table-column prop="final_draft_examine_num" label="终稿验证次数" min-width="95" align="center" />
                <el-table-column label="操作" width="220" align="center" fixed="right">
                    <div style="margin: -3px;" slot-scope="scope">
                        <el-button style="margin: 3px;" size="mini" @click="checkOrderDetail(scope.row)">{{ scope.row.state
                            === 0 ? "审核" : "订单信息" }}</el-button>
                        <el-button style="margin: 3px;" size="mini" @click="checkUserProfile(scope.row)">查看信息</el-button>
                        <el-button style="margin: 3px;" v-if="scope.row.evaluation.type === 1" size="mini"
                            @click="checkAddress(scope.row.user_address_log)">查看地址</el-button>
                        <template v-if="(scope.row.state >= 4 && scope.row.state <= 9) || scope.row.state == 13">
                            <el-button style="margin: 3px;"
                                v-if="(scope.row.state >= 4 && scope.row.state <= 9) || scope.row.state == 13" size="mini"
                                @click="checkFirstDraft(scope.row, '查看初稿')">查看初稿</el-button>
                            <el-button style="margin: 3px;"
                                v-if="(scope.row.state >= 7 && scope.row.state <= 9) || scope.row.state == 13" size="mini"
                                @click="checkFinalDraft(scope.row, '查看终稿')">查看终稿</el-button>
                        </template>


                        <el-button v-if="scope.row.state === 1 &&
                            scope.row.evaluation.type === 1 &&
                            scope.row.is_agree
                            " type="primary" style="margin: 3px;" size="mini"
                            @click="onShowLogisticModal(scope.row.order_id)">发货</el-button>



                        <el-button style="margin: 3px;" size="mini"
                            v-if="(scope.row.state === 3 || scope.row.state === 5)"
                            @click="submitFirstDraft(scope.row, '提交初稿')">提交初稿</el-button>
                        <el-button style="margin: 3px;" size="mini"
                            v-if="(scope.row.state === 6 || scope.row.state === 8)"
                            @click="submitFinishDraft(scope.row, '提交终稿')">提交终稿</el-button>
                        <!-- <el-button style="margin: 3px;" size="mini"
                            v-if="scope.row.state === 10 && (scope.row.before_state === 3 || scope.row.before_state === 5 || scope.row.before_state === 6 || scope.row.before_state === 8)" -->
                        <el-button style="margin: 3px;" size="mini"
                            v-if="scope.row.state === 10"
                            @click="updateOrderState(scope.row, '修改订单状态')">修改订单状态</el-button>
                        <el-button style="margin: 3px;" size="mini" v-if="is_grant_integral === 1 && scope.row.state === 13"
                            @click="sendIntegral(scope.row, '发放积分')">发放积分</el-button>



                        <el-button v-if="scope.row.state === 2" type="primary" size="mini" style="margin: 3px;"
                            @click="onSignature(scope.row.order_id)">签收</el-button>
                        <el-button v-if="scope.row.state === -1" type="primary" size="mini" style="margin: 3px;"
                            @click="onRePass(scope.row.order_id)">修改审核</el-button>

                        <el-button style="margin: 3px;" size="mini" type="danger" v-if="scope.row.state >= 1 && scope.row.state <= 3 && scope.row.is_agree === 1 &&
                            (scope.row.questionnaires_state === null || (scope.row.questionnaires_state >= 1 && scope.row.questionnaires_state <= 3))
                            " @click="closeOrder(scope.row, '关闭订单')">关闭订单</el-button>
                    </div>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                    :total="total" background layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>

        <CheckAddressModal v-if="addressVisible" :show.sync="addressVisible" :addressData="modalData" />
        <OrderDetailModal v-if="orderDetailVisible" :show.sync="orderDetailVisible" :detailData="modalData"
            @onUpdate="onTableActionModalSubmit" />
        <UserProfileModal v-if="userProfileVisible" :show.sync="userProfileVisible" :userID="modalData.user_id"
            :showRemark="true" @onUpdate="getList" />
        <!-- <FirstSubmitDraftModal v-if="submitFirstDraftModal" :show.sync="submitFirstDraftModal" :draftData="modalData"
            @onUpdate="onTableActionModalSubmit" /> -->
        <!-- <FinalSubmitDraftModal v-if="submitFinalDraftModal" :show.sync="submitFinalDraftModal" :draftData="modalData"
            @onUpdate="onTableActionModalSubmit" /> -->
        <FirstDraftModal v-if="firstDraftVisible" :show.sync="firstDraftVisible" :draftData="modalData"
            @onUpdate="onTableActionModalSubmit" />
        <UpdateOrderState v-if="updateOrderStateModal" :show.sync="updateOrderStateModal" :draftData="modalData"
            @onUpdate="onTableActionModalSubmit" />
        <FinalDraftModal v-if="finalDraftVisible" :show.sync="finalDraftVisible" :draftData="modalData"
            @onUpdate="onTableActionModalSubmit" />
        <LogisticsModal v-if="logisticsVisible" :show.sync="logisticsVisible" :order_id="modalData"
            @onUpdate="onTableActionModalSubmit" />
    </div>
</template>

<script>
import CheckAddressModal from "./components/CheckAddressModal.vue";
import OrderDetailModal from "./components/OrderDetailModal.vue";
import UserProfileModal from "@/components/UserProfileModal/index.vue";
import FirstSubmitDraftModal from "./components/FirstSubmitDraftModal.vue";
import FinalSubmitDraftModal from "./components/FinalSubmitDraftModal.vue";
import UpdateOrderState from "./components/UpdateOrderState.vue";
import FirstDraftModal from "./components/FirstDraftModal.vue";
import FinalDraftModal from "./components/FinalDraftModal.vue";
import LogisticsModal from "./components/LogisticsModal.vue";
import { zhongcao } from "@/api/order";
import { review } from "@/api/review";
import store from '@/store'
import * as XLSX from "xlsx";
import { checkPlatform } from "@/utils/common"

export default {
    data: () => ({
        is_grant_integral: '',
        tableData: [],
        tableLoading: false,
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            product_name: "",
            user_name: "",
            is_merchant_activity: "",
            type: null,
            evaluation_class_id: null,
        },
        classifyLoading: false,
        classifyList: [],
        submitFirstForm: {
            title: '',
            content: '只计算得分几热国土局埃弗顿工卡何如哈维只计算得分几热国土局埃弗顿工卡何如哈维只计算得分几热国土局埃弗顿工卡何如哈维',
            cover_img: [],
        },
        submitting: false,
        // 拟态
        addressVisible: false,
        orderDetailVisible: false,
        userProfileVisible: false,
        firstDraftVisible: false,
        finalDraftVisible: false,
        logisticsVisible: false,
        submitFirstDraftModal: false,
        submitFinalDraftModal: false,
        updateOrderStateModal: false,
        modalData: {},
        modalTitle: '',
        platformList: [],
    }),
    components: {
        FirstSubmitDraftModal,
        FinalSubmitDraftModal,
        FirstDraftModal,

        CheckAddressModal,
        OrderDetailModal,
        UserProfileModal,
        UpdateOrderState,
        FinalDraftModal,
        LogisticsModal,
    },
    computed: {

    },
    methods: {
        // 关闭订单
        async closeOrder(value, title) {
            this.$confirm(`此操作将关闭订单, 是否继续?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                await zhongcao.closeOrderServer({ order_id: value.order_id });
                this.$message({
                    message: "已关闭订单！",
                    type: "success",
                });
                this.getList();
            })
        },
        async sendIntegral(data, title) {
            this.$confirm(`此操作将发放积分, 是否继续?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                await zhongcao.integral(data.order_id);
                this.$message({
                    message: "已发放积分！",
                    type: "success",
                });
                this.getList();
            })

        },
        onSubmitFirst(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        this.submitting = true;
                        // await zhongcao.firstDraftReview({ type: 2, ...this.form });
                        this.$message({
                            message: "已提交",
                            type: "success",
                        });
                    } catch {
                        this.$message.error("出错了!");
                    } finally {
                        this.submitting = false;
                    }
                }
            });
        },
        async getList() {
            this.tableLoading = true;
            this.tableData = []
            const { data } = await zhongcao.list(this.listQuery);
            this.tableData = data.data;
            this.tableData.forEach((dataItem, i) => {
                dataItem.channel_pathList = []
                let channelValue = dataItem.channel_id != null ? dataItem.channel_id : dataItem.evaluation.channels
                channelValue.split(',').forEach(item => {
                    dataItem.channel_pathList.push(checkPlatform(item).path)
                })

            });
            this.total = data.total;
            this.tableLoading = false;
        },
        async onChangeType(type) {
            this.listQuery.evaluation_class_id = null;
            this.classifyLoading = true;
            const { data } = await review.classify(type);
            this.classifyList = data;
            this.classifyLoading = false;
        },
        handleFilter() {
            this.listQuery.page = 1;
            this.getList();
        },
        onRePass(order_id) {
            this.$confirm("此操作将通过审核, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(async () => {
                    try {
                        await zhongcao.applicationPass(order_id);
                        this.$message({
                            type: "success",
                            message: "已通过审核!",
                        });
                        this.getList();
                    } catch {
                        this.$message.error("出错了!");
                    }
                })
                .catch(() => {
                    this.$message("审核取消!");
                });
        },
        onSignature(id) {
            this.$confirm("此操作将确认签收, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(async () => {
                    try {
                        await zhongcao.signature(id);
                        this.$message({
                            type: "success",
                            message: "已确认签收!",
                        });
                        this.getList();
                    } catch {
                        this.$message.error("出错了!");
                    }
                })
                .catch(() => {
                    this.$message("签收取消!");
                });
        },
        onClearType() {
            this.listQuery.evaluation_class_id = null;
        },
        checkOrderDetail(data) {
            this.modalData = data;
            this.orderDetailVisible = true;
        },
        checkUserProfile(data) {
            this.modalData = data;
            this.userProfileVisible = true;
        },
        checkAddress(address) {
            this.modalData = address;
            this.addressVisible = true;
        },
        checkFirstDraft(data) {
            this.modalData = data;
            this.firstDraftVisible = true;
        },
        // checkFirstDraft({order_id, title}) {
        //     this.$router.push({
        //         name: "FirstDraft",
        //         params: { id:order_id },
        //         query: { title }
        //     });
        // },
        checkFinalDraft(data, title) {
            this.modalData = data;
            this.finalDraftVisible = true;
        },
        submitFirstDraft(data, title) {
            // this.modalData = data;
            // this.submitFirstDraftModal = true;
            this.$router.push({
                name: "FirstSubmitDraft",
                params: { id: data.order_id },
                query: { title }
            });
        },
        submitFinishDraft(data, title) {
            // this.modalData = data;
            // this.submitFirstDraftModal = true;
            this.$router.push({
                name: "FinalSubmitDraft",
                params: { id: data.order_id },
                query: { channel_id: data.channel_id ? data.channel_id : data.evaluation.channels }
            });
        },
        updateOrderState(data, title) {
            this.modalData = data;
            this.updateOrderStateModal = true;
        },
        onShowLogisticModal(order_id) {
            this.modalData = order_id;
            this.logisticsVisible = true;
        },
        onTableActionModalSubmit() {
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        // 导出Excel
        async exportExcel() {
            console.log("exportExcel");
            // +++修改excel-订单管理-订单列表-测评-附件3---ok
            const { total } = this;
            if (!total) return;

            try {
                const {
                    data: { data: reqData },
                } = await zhongcao.exportOrderReviewExcel({ ...this.listQuery, page: 1, limit: 99999999999 });
                console.log(reqData);

                // 重置推广数据
                reqData.forEach(reqDataItem => {
                    // 渠道数据
                    reqDataItem.channelsLists = []
                    // 投稿平台
                    reqDataItem.channelsTitle = ''
                    // 探店日期
                    reqDataItem.toStoreDate = ''
                    reqDataItem.chuGao = ''

                    // 不是问卷
                    if (reqDataItem.evaluation.order_type !== 2) {

                        // reqDataItem.channelsTitle
                        if (reqDataItem.channel_id) {
                            // reqDataItem.channelsTitle = checkPlatform(reqDataItem.channel_id).name
                            reqDataItem.channelsTitle = reqDataItem.channel_id.split(',').map(item => {
                                let platform = checkPlatform(item)
                                return platform.name
                            }).join('+')
                        } else {
                            if (reqDataItem.evaluation.channels) {
                                reqDataItem.channelsTitle = reqDataItem.evaluation.channels.split(',').map(item => {
                                    let platform = checkPlatform(item)
                                    return platform.name
                                }).join('+')
                            } else {
                                reqDataItem.channelsTitle = ''
                            }
                        }

                        // reqDataItem.toStoreDate
                        if (reqDataItem.evaluation.type === 2 && reqDataItem.to_store_at_datas && reqDataItem.to_store_at_datas.length > 0) {
                            reqDataItem.toStoreDate = reqDataItem.to_store_at_datas.join('，')
                        }
                    }
                    // 有初稿
                    if (reqDataItem.new_first_draft_content && reqDataItem.new_first_draft_content.length > 0) {
                        reqDataItem.new_first_draft_content.forEach((item, index) => {
                            reqDataItem.chuGao += `${index + 1}\n标题：${item.first_draft_title}\n内容：${item.first_draft_content}\n链接：${item.first_draft_url.map(item => item.path).join('\n')}\n提交时间：${item.first_submit_at}\n`
                        })
                    }


                })

                var wb = XLSX.utils.book_new();

                var excelData = [
                    [
                        "订单号",
                        "用户名",
                        "性別", "年龄", "手机号", "居住地-国家", "居住地-省份", "微信ID", "邮箱", "擅长领域", "活动名称", "投稿平台",
                        "商家", //11
                        "测评类型",
                        "分类", //11
                        "探店日期", "初稿内容",
                        "申请次数",
                        "初稿审核次数",
                        "终稿验证次数",
                        "提交时间",
                        "状态",
                    ],
                    ...reqData.map((item) => {
                        if (item.user_info) {
                            return [
                                item.order_id,
                                item.user_info.name,
                                item.user_info.gender === 1 ? '男性' : item.user_info.gender === 2 ? '女性' : '未设置',
                                item.user_info.age_group === 1 ? '20岁以下' : item.user_info.age_group === 2 ? '21~30岁' : item.user_info.age_group === 3 ? '31~40岁' : item.user_info.age_group === 4 ? '41~50岁' : item.user_info.age_group === 5 ? '51岁以上' : '未设置',
                                item.user_info.account,
                                item.user_info.country,
                                item.user_info.provinces,
                                item.user_info.wx_id,
                                item.user_info.email,
                                item.user_info.evaluation_type_field.length > 0 ? item.user_info.evaluation_type_field.map(item => item.name).join(',') : '',
                                item.evaluation.name,
                                item.channelsTitle,
                                item.evaluation.merchant_info.name, // 11
                                item.evaluation.type === 1 ? "产品体验" : item.evaluation.type === 2 ? "探店体验" : "无字段",
                                item.evaluation.evaluation_class_info.name, // 11
                                item.toStoreDate,
                                item.chuGao,
                                item.application_number, // 申请次数
                                item.first_draft_examine_num,
                                item.final_draft_examine_num,
                                item.created_at,
                                item.state === 0
                                    ? "申请中"
                                    : item.state === -1
                                        ? "申请失败"
                                        : item.state === 1
                                            ? "申请成功"
                                            : item.state === 2
                                                ? "已发货"
                                                : item.state === 3
                                                    ? "待提交初稿"
                                                    : item.state === 4
                                                        ? "待审核初稿"
                                                        : item.state === 5
                                                            ? "初稿审核失败"
                                                            : item.state === 6
                                                                ? "待提交终稿"
                                                                : item.state === 7
                                                                    ? "待审核终稿"
                                                                    : item.state === 8
                                                                        ? "终稿审核失败"
                                                                        : item.state === 9
                                                                            ? "已完成"
                                                                            : item.state === 10
                                                                                ? "订单已关闭"
                                                                                : item.state === 11
                                                                                    ? "订单已取消"
                                                                                    : item.state === 12
                                                                                        ? "选择我不去了"
                                                                                        : item.state === 13
                                                                                            ? "待发放积分"
                                                                                            : "后端无字段",
                            ]

                        }
                    }),
                ];
                var ws = XLSX.utils.aoa_to_sheet(excelData);
                XLSX.utils.book_append_sheet(wb, ws, "订单管理");
                XLSX.writeFile(wb, "订单管理-订单列表-测评详情.xlsx");

                this.$notify.info({
                    title: "消息",
                    message: "请等待, 正在生成Excel表格文件...",
                });
            } catch {
                this.$notify.error({
                    title: "错误",
                    message: "获取数据错误!",
                });
            }
        },
        async initOption() {
            const { data: platformList } = await review.platformList()
            this.platformList = platformList
        },
    },
    created() {
        this.getList();
        this.initOption()
        this.is_grant_integral = store.getters.is_grant_integral
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped >
.filter-head {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    margin: -5px;

    .filter-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-end;
        margin: -5px -10px;

        &>.filter-item {
            margin: 5px;
        }
    }


}

// .table {
//     margin-top: 20px;

//     .table-operations {
//         margin-bottom: 10px;
//     }
// }
</style>
